__turbopack_context__.v({
  "lig": "_2kSe0a_lig",
  "root": "_2kSe0a_root",
});
